// todo once we get appropriate solution from Bernie, we will remove this
//  https://github.expedia.biz/Brand-Expedia/bernie/issues/1169
export const preConnectOrigins = (): void => {
  const originList = [
    'http://om.expedia.com',
    'https://www.uciservice.com',
    'https://oms.expedia.com',
    'https://www.trvl-px.com',
    'https://b.travel-assets.com',
    'https://www.googletagmanager.com',
    'https://tags.tiqcdn.com'
  ];

  originList.map(item => {
    const linkElement = document.createElement('link');
    linkElement.rel = 'preconnect';
    linkElement.href = item;
    document.head.appendChild(linkElement);
  });
};
